import { useCallback } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { tasksApi } from '../api';

// Prefs del panel de cuadro de trabajo (ancho del índice, columna de doc contraída),
// espejadas en `/api/customs` — integración main→dev, epic D1. React Query, NO `localStore.js`
// (su docstring excluye el estado espejado en servidor). Escritura optimista + fire-and-forget:
// el valor local del contenedor manda mientras la request vuela; ignora la carga tardía.
export function useWorkframePref(userId, key, { enabled = true, coerce = (v) => v } = {}) {
    const qc = useQueryClient();
    const queryKey = ['tasks', 'workframe-pref', userId, key];

    const query = useQuery({
        queryKey,
        queryFn: async () => {
            const data = await tasksApi.fetchWorkframePref(userId, key);
            const raw = data?.value !== undefined ? data.value : data?.custom?.value;
            return data?.success && raw !== undefined && raw !== null ? coerce(raw) : null;
        },
        enabled: !!userId && enabled,
        refetchOnWindowFocus: false,
        staleTime: Infinity,
    });

    const save = useCallback((value) => {
        qc.setQueryData(['tasks', 'workframe-pref', userId, key], coerce(value)); // optimista
        if (userId) tasksApi.saveWorkframePref(userId, key, value).catch(() => {});
    }, [qc, userId, key, coerce]);

    return { value: query.data, isLoaded: query.isFetched, save };
}
